import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Box, Button, useMediaQuery } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { COLORS } from '../../constants';
import { useMsal } from "@azure/msal-react";
import { useAuth } from "../../AuthContext";

const Header: React.FC = () => {

    const { instance, accounts } = useMsal();
    const { isAdmin, isManager } = useAuth();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [userName, setUserName] = useState("");

    useEffect(() => {
        if (accounts.length > 0) {
            const account = accounts[0];
            setUserName(account.name || "");
        }
    }, [accounts]);

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin
        });
    };

    const handleLogoClick = () => {
        window.location.assign('/my-activity');
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                backgroundColor: theme.palette.mode === 'dark' ? '#020617' : COLORS.white,
                color: theme.palette.mode === 'dark' ? '#e5e7eb' : COLORS.winwireBlue,
                boxShadow: theme.palette.mode === 'dark'
                    ? '0px 2px 6px rgba(0,0,0,0.6)'
                    : '0px 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1100,
            }}
        >
            <Toolbar
                sx={{
                    minHeight: '64px !important',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    gap: isMobile ? 1 : 0,
                }}
            >

                {/* LEFT */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'nowrap',
                            overflow: 'hidden'
                        }}
                    >
                        <Typography
                            variant="h6"
                            onClick={handleLogoClick}
                            sx={{
                                fontWeight: 700,
                                fontSize: isMobile ? '16px' : '20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                cursor: 'pointer'
                            }}
                        >
                            <img
                                src="/icons/WinEngage.svg"
                                alt="logo"
                                style={{
                                    height: isMobile ? '32px' : '40px',
                                    width: isMobile ? '120px' : '160px',
                                    objectFit: 'contain'
                                }}
                            />
                        </Typography>

                        {!isMobile && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: COLORS.textSecondary,
                                    fontSize: '14px',
                                    borderLeft: `2px solid ${COLORS.borderGray}`,
                                    paddingLeft: 2,

                                    '@media (prefers-color-scheme: dark)': {
                                        color: '#94a3b8',
                                        borderLeft: '2px solid rgba(255,255,255,0.2)',
                                    }
                                }}
                            >
                                Smart Talent Utilization & Accelerator Engine
                            </Typography>
                        )}
                    </Box>
                </Box>

                {/* RIGHT */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: isMobile ? 1 : 3,
                        flexShrink: 0,
                    }}
                >

                    <Box sx={{ textAlign: 'right' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: isMobile ? 12 : 14 }}>
                            {userName}
                        </Typography>

                        {isAdmin && (
                            <Typography className="admin-role-label" sx={{ color: 'red', fontSize: 12 }}>
                                Admin
                            </Typography>
                        )}

                        {isManager && !isAdmin && (
                            <Typography sx={{ color: 'green', fontSize: 12 }}>
                                Manager
                            </Typography>
                        )}
                    </Box>

                    <Button
                        variant="contained"
                        color="error"
                        startIcon={<LogoutIcon />}
                        onClick={handleLogout}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: isMobile ? '12px' : '14px',
                            padding: isMobile ? '4px 8px' : '6px 16px'
                        }}
                    >
                        Logout
                    </Button>

                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;